/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable prettier/prettier */
import { Avatar, Button, Card, CardHeader, Grid, IconButton, TextareaAutosize, Tooltip, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { IconHeart, IconRepeat, IconMessageDots } from '@tabler/icons';
import axios from 'axios';
import useAuth from 'hooks/useAuth';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import TweetsyConfig from 'TweetsyConfig';
import { ReactSession } from 'react-client-session';

ReactSession.setStoreType("localStorage");

const EngagementCard = ({ tweet, liked, setLikedTweet, replyed, setRepliedTweet, uid, setSkippedTweet }) => {
    const theme = useTheme();
    const [replyValue, setReplyValue] = useState('');
    const maxLength = 280;
    const [isLiked, setIsLiked] = useState(!!liked)
    const [isLoading, setIsLoading] = useState(false)

    // extra safety
    const [likeInProcess, setLikeInProcess] = useState(false)
    const [isReplyGenerating, setIsReplyGenerating] = useState(false)



    const { dbUser } = useAuth();
    const { accountProfImage, accountScreeName, favoriteCount, retweetCount, text, tweetIDSTR, tweeted_at } = tweet;


    const tweetedAtLocal = new Date(tweet.tweeted_at).toString().split(' ').slice(1, -4).join(' ');

    const handleReply = e => {
        e.preventDefault();
        console.log('reply');
        // /engagement/reply/:userID/:urlID/:screenName
        axios.post(`${TweetsyConfig.getNodeUrl()}engagement/reply/${dbUser._id}/${tweetIDSTR}/${accountScreeName}`, { twitReply: replyValue })
            .then(res => {
                console.log('❤ Reply done\n', res.data)
                setReplyValue('')
                toast('Replied successfully', {
                    autoClose: 2500,
                    type: 'success',
                    hideProgressBar: true
                });

                setRepliedTweet(val => [...val, tweetIDSTR])

                // add to liked array
                // setLikedTweet(val => [...val, { likedTweetID: tweet.tweetIDSTR }])
                // setIsLiked(val => !val)
                // setIsLiked(true)

            }).catch(e => {
                console.log('🤐error on reply', e)
                toast('Reply failed, please try again', {
                    autoClose: 2500,
                    type: 'error',
                    hideProgressBar: true
                });
            })
    }

    // AI Reply Generator START======================
    const replyGenaretor = () => {
        // Toastify- show loading toast
        const loadingAI = toast.loading('Generating ....');
        setIsReplyGenerating(true)

        const reqBody = {
            inputs: { text }
        }

        axios
            .post('https://e0w71gglzd.execute-api.us-east-1.amazonaws.com/prod/reply1', reqBody)
            .then(res => {
                console.log("🚀 ~ file: index.js ~ line 79 ~ replyGenaretor ~ res", res);

                if (res.data.body) {
                    toast.update(loadingAI, {
                        render: 'Reply generated',
                        type: 'success',
                        isLoading: false,
                        autoClose: 500
                    });

                    setReplyValue(res.data?.body?.generated_text)

                } else {
                    toast.update(loadingAI, {
                        render: 'Something went wrong!',
                        type: 'error',
                        isLoading: false,
                        autoClose: 1000
                    });
                }

            }).catch(err => {
                console.log('🧪 Got an error on AI\n', err)
                toast.update(loadingAI, {
                    render: 'Failed! Please try again.',
                    type: 'error',
                    isLoading: false,
                    autoClose: 1000
                });
            }).finally(() => {
                setIsReplyGenerating(false)
            })
    }
    // AI Reply Generator END======================


    const handleLike = () => {
        setLikeInProcess(true)
        axios.get(`${TweetsyConfig.getNodeUrl()}${isLiked ? 'dislike' : 'like'}/${dbUser._id}/${tweetIDSTR}`)
            .then(res => {
                console.log('🧪 Like', res.data)
                toast(`💗 ${isLiked ? 'removed' : 'added'}`, {
                    autoClose: 2500,
                    type: 'success',
                    hideProgressBar: true
                });
                // add to liked array
                // setLikedTweet(val => [...val, { likedTweetID: tweet.tweetIDSTR }])
                setIsLiked(val => !val)

            }).catch(e => {
                console.log('🤐error on like', e)
                toast('Something went worng!', {
                    autoClose: 2500,
                    type: 'error',
                    hideProgressBar: true
                });
            }).finally(() => {
                setLikeInProcess(false)
            })
    }

    const handleRetweet = () => {
        axios.get(`${TweetsyConfig.getNodeUrl()}retweet/${dbUser._id}/${tweetIDSTR}`)
            .then(res => {
                console.log('🧪 retweet', res.data)
                toast('Retweeted Successfully', {
                    autoClose: 2500,
                    type: 'success',
                    hideProgressBar: true
                });
            }).catch(e => {
                console.log('🤐error on retweet', e)
                toast('Something went worng!', {
                    autoClose: 2500,
                    type: 'error',
                    hideProgressBar: true
                });
            })
    }

    const handleSkipBtn = () => {
        console.log("🚀 ~ file: index.js ~ line 107 ~ handleSkipBtn ~ tweetIDSTR", tweetIDSTR);
        setIsLoading(true)
        axios
            // .get(`http://localhost:5000/skipTweet/${uid}/${tweet.tweetIDSTR}`)
            .get(`${TweetsyConfig.getNodeUrl()}skipTweet/${uid}/${tweet.tweetIDSTR}`)
            .then(res => {
                // console.log("🚀 ~ file: index.js ~ line 111 ~ handleSkipBtn ~ res", res);
                setSkippedTweet(val => {

                    ReactSession.set("skippedTweet", [...val, tweet.tweetIDSTR])
                    return [...val, tweet.tweetIDSTR]
                })

            }).catch(err => {
                console.log("🚀 ~ file: index.js ~ line 113 ~ handleSkipBtn ~ err", err);
                setIsLoading(false)
            }).finally(() => {
            })
    }

    return (
        <Card
            sx={{
                p: 3,
                pt: 4,
                // pr: 3,
                mb: 3,
                background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                border: theme.palette.mode === 'dark' ? '1px solid transparent' : `1px solid${theme.palette.grey[100]}`,
                '&:hover': {
                    borderColor: theme.palette.primary.main
                },
                position: 'relative'
            }}
        >
            {/* skip btn */}
            <Button
                color="info"
                // variant="contained"
                size="small"
                disabled={isLoading}
                sx={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px'
                }}
                onClick={handleSkipBtn}
            >Skip</Button>





            <Grid
                container
                spacing={5}
            // columns={{ md: 2, xs: 1 }}
            >
                {/* ====================== Left ====================== */}
                <Grid item md={6} xs={12} >
                    <Card sx={{ background: 'none' }}>
                        <CardHeader
                            avatar={<Avatar alt={accountScreeName} src={accountProfImage} sx={{ width: 48, height: 48 }} />}
                            // avatar={<Avatar alt='F' src='http://pbs.twimg.com/profile_images/1502279804795727873/ZOww8imF_normal.jpg' sx={{ width: 48, height: 48 }} />}
                            titleTypographyProps={{ variant: 'h3' }}
                            title={accountScreeName}
                            subheader={tweetedAtLocal}

                            sx={{
                                p: 0,
                                pb: 2
                            }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                color: theme.palette.grey[700],
                                pb: 3,
                                pl: '60px'
                                // pr: '20px'
                            }}
                        >
                            {text}
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: theme.palette.grey[500],

                            }}
                        >
                            <IconButton
                                onClick={handleLike}
                                disabled={likeInProcess}
                            >

                                {isLiked ? <IconHeart color='#f91880' fill='#f91880' />
                                    :
                                    <IconHeart />
                                }
                            </IconButton >
                            <Typography sx={{ pr: 1 }}>{isLiked ? favoriteCount + 1 : favoriteCount} </Typography>
                            <IconButton
                                onClick={handleRetweet}
                            >
                                <IconRepeat />
                            </IconButton>
                            <Typography >{retweetCount} </Typography>
                        </Box>
                    </Card>
                </Grid>

                {/* ====================== Right ====================== */}
                <Grid item md={6} xs={12} >
                    {replyed && <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <IconMessageDots />
                        <Typography>Already Replied</Typography>
                    </Box>}
                    <form onSubmit={handleReply} >
                        <TextareaAutosize
                            value={replyValue}
                            onChange={e => setReplyValue(e.target.value)}
                            minRows={6}
                            style={{
                                background: '#ffffff14',
                                width: '100%',
                                borderRadius: '7px',
                                border: '1px solid #00000024',
                                marginTop: '10px',
                                fontFamily: 'Roboto',
                                padding: '5px 10px'
                            }}
                        />

                        <Box>
                            <Typography sx={{ color: replyValue.length > maxLength ? theme.palette.error.main : theme.palette.grey[500] }}>{replyValue.length}/{maxLength}</Typography>
                        </Box>

                        <Box sx={{ textAlign: 'right' }}>
                            <Tooltip title="AI Reply generator"  >
                                <IconButton size='small'
                                    disabled={isReplyGenerating}
                                    sx={{ mr: 1 }}
                                    color="default"
                                    onClick={replyGenaretor}
                                >
                                    <img src="ai.png" alt="icom" height='20px' width='20px' />
                                </IconButton>
                            </Tooltip>
                            <Button
                                type='submit'
                                variant="outlined"
                                size="small"
                            // onClick={handleCopyTwweet}
                            >Reply</Button>
                        </Box>
                    </form>
                </Grid>

            </Grid>
        </Card>
    );
};

export default EngagementCard;